import { Component, Inject, OnInit } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';

export interface DialogData {
  message: string;
}


@Component({
  selector: 'app-invalid-refund-notice',
  templateUrl: './invalid-refund-notice.component.html',
  styleUrls: ['./invalid-refund-notice.component.scss']
})
export class InvalidRefundNoticeComponent implements OnInit {
  
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit(): void {
  }

}
